"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4271],{

/***/ 4271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MovieBanner": function() { return /* binding */ MovieBanner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var plyr_dist_plyr_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5667);
/* harmony import */ var plyr_dist_plyr_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(plyr_dist_plyr_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(83321);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(54799);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(15861);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(44012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _shared_bookmark_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48185);
/* harmony import */ var _mui_material_Drawer__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(58826);
/* harmony import */ var _mui_icons_material_PlayArrow__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(58989);
/* harmony import */ var plyr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21443);
/* harmony import */ var plyr__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(plyr__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43795);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(60374);
/* harmony import */ var _logic_state_dialog__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36343);
/* harmony import */ var _hooks_use_film_formatter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95102);
/* harmony import */ var _logic_state_snackbar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11224);
/* harmony import */ var _shared_close_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4997);
/* harmony import */ var _shared_movie_details_info__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2155);
/* harmony import */ var _shared_image_box_future__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58718);



















var copiedIcon = "/icons/movie-details/copied.svg";
var shareWhiteIcon = "/icons/shared/share-white.svg";
var timeIcon = "/icons/movie-details/time.svg";
var videoOptions = {
    controls: [
        "play-large",
        "restart",
        "rewind",
        "play",
        "progress",
        "current-time",
        "duration",
        "mute",
        "volume",
        "captions",
        "settings",
        "pip",
        "airplay",
        "download",
        "start",
        "end",
        "captions",
        "stop", 
    ],
    disableContextMenu: false
};
var MovieBanner = function(movieBannerProps) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    var setSnack = (0,_logic_state_snackbar__WEBPACK_IMPORTED_MODULE_8__/* .useSnack */ .e)(function(s) {
        return s.setSnack;
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z);
    var ref36 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), playState = ref36[0], setPlayState = ref36[1];
    var setDialog = (0,_logic_state_dialog__WEBPACK_IMPORTED_MODULE_6__/* .useDialog */ .R)(function(s) {
        return s.setDialog;
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z);
    var ref37 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(false), 2), drawerState = ref37[0], setDrawerState = ref37[1];
    var videoId = movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref = movieBannerProps.data) === null || ref === void 0 ? void 0 : (ref1 = ref.film) === null || ref1 === void 0 ? void 0 : ref1.trailerUrl;
    var ref38 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var closeCurrentDialog = function() {
        setDialog({});
    };
    var toggleDrawer = function(open) {
        return function(event) {
            if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
                return;
            }
            setDrawerState(open);
        };
    };
    var checkPlaying = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var ref, ref1;
        ((ref1 = (ref = ref38.current) === null || ref === void 0 ? void 0 : ref.plyr) === null || ref1 === void 0 ? void 0 : ref1.playing) ? setPlayState(true) : setPlayState(false);
    }, []);
    var checkPlaying2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var ref, ref1;
        (ref1 = (ref = ref38.current) === null || ref === void 0 ? void 0 : ref.plyr) === null || ref1 === void 0 ? void 0 : ref1.play();
        checkPlaying();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var ref39 = (0,_hooks_use_film_formatter__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref2 = movieBannerProps.data) === null || ref2 === void 0 ? void 0 : ref2.film), formattedDuration = ref39.formattedDuration, durationWithRateWithRtl = ref39.durationWithRateWithRtl;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        new (plyr__WEBPACK_IMPORTED_MODULE_4___default())("#player", videoOptions);
    }, []);
    var handleTrailerURL = function(link) {
        var modifiedLink = "";
        //  link.replace('youtube.com', 'youtube-nocookie.com');
        modifiedLink = link.replace("watch?v=", "embed/");
        if (link.includes("youtu.be/")) {
            modifiedLink = modifiedLink.replace("youtu.be/", "www.youtube.com/embed/");
        }
        return modifiedLink;
    };
    var _obj, _obj1, _obj2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            component: "div",
            sx: {
                height: {
                    mobile: "calc(50vh - 56px)",
                    laptop: "calc(100vh - 100px)",
                    mediumDesktop: "calc(100vh - 100px)"
                },
                position: "relative",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                background: "linear-gradient(180deg, rgba(0, 0, 0, 0.87) 7.33%, rgba(0, 0, 0, 0) 47.54%), linear-gradient(256.27deg, #171A1F 0%, rgba(23, 26, 31, 0) 107.57%),url(".concat(movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref3 = movieBannerProps.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.film) === null || ref4 === void 0 ? void 0 : ref4.coverUrl, ")"),
                backgroundPosition: "top center",
                backgroundSize: "cover",
                overflow: "hidden"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    component: "div",
                    sx: {
                        position: "absolute",
                        bottom: "16px",
                        right: "16px",
                        zIndex: 3
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                onClick: toggleDrawer(true),
                                variant: "contained",
                                sx: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                                    fontSize: "14px",
                                    width: "108px",
                                    height: "40px",
                                    background: theme.palette.lightGrey.main,
                                    color: theme.palette.grey[80],
                                    fontWeight: 700,
                                    p: 0,
                                    display: "none",
                                    "@keyframes translateInfo": {
                                        "0%": {
                                            opacity: 1
                                        },
                                        "100%": {
                                            opacity: 0
                                        }
                                    }
                                }, theme.breakpoints.down("laptop"), {
                                    display: playState ? "none" : "initial"
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    id: "movie_details.more_info"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Drawer__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                                anchor: "bottom",
                                open: drawerState,
                                onClose: toggleDrawer(false),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        component: "div",
                                        sx: {
                                            pl: "30px",
                                            py: "38px",
                                            position: "relative",
                                            display: "inline",
                                            width: "70px",
                                            height: "66px"
                                        },
                                        onClick: toggleDrawer(false),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_close_button__WEBPACK_IMPORTED_MODULE_9__/* .CloseButton */ .P, {})
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_movie_details_info__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .C, {
                                        data: movieBannerProps.data
                                    })
                                ]
                            })
                        ]
                    }, "bottom")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    component: "div",
                    sx: {
                        width: "100%",
                        height: "100%",
                        maxHeight: "100%",
                        position: "absolute",
                        top: "0"
                    },
                    onClick: checkPlaying,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        component: "div",
                        sx: {
                            "& ::after": {
                                position: "absolute",
                                top: 0,
                                left: 0,
                                zIndex: playState ? "10" : "1",
                                width: playState ? "0%" : "100%",
                                height: videoId ? "100%" : "0",
                                content: "''",
                                backgroundImage: "linear-gradient(180deg, rgba(0, 0, 0, 0.87) 7.33%, \n                    rgba(0, 0, 0, 0) 47.54%), linear-gradient(256.27deg, #171A1F 0%, rgba(23, 26, 31, 0) 107.57%)",
                                animation: playState ? "translateInfo 1500ms ".concat(theme.transitions.easing.easeInOut, " both ") : ""
                            },
                            "--plyr-color-main": theme.palette.primary.main,
                            "& .plyr__poster": {},
                            "& .plyr--video": {
                                height: {
                                    mobile: "calc(50vh - 56px)",
                                    laptop: "calc(100vh - 100px)",
                                    mediumDesktop: "calc(100vh - 100px)"
                                },
                                "& .plyr__control.plyr__control--overlaid": {
                                    background: "rgba(255, 255, 255, 0.5)",
                                    backdropFilter: "blur(24px)",
                                    width: {
                                        laptop: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(156),
                                        tablet: "58px"
                                    },
                                    height: {
                                        laptop: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(156),
                                        tablet: "58px"
                                    },
                                    display: {
                                        laptop: "flex",
                                        tablet: "none",
                                        mobile: "none"
                                    },
                                    alignItems: "center",
                                    justifyContent: "center"
                                },
                                "& .plyr__control--overlaid": (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, theme.breakpoints.down(460), {
                                    right: "25px",
                                    left: "auto"
                                })
                            },
                            ".plyr__controls": {
                                display: !playState ? "none !important" : "flex"
                            },
                            "& .plyr__control::after": {
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "0%",
                                height: "0%"
                            },
                            "&  .plyr__control--overlaid svg": {
                                width: "".concat((0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(37), " !important"),
                                height: "".concat((0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(37), " !important")
                            }
                        },
                        children: videoId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            className: "plyr__video-embed",
                            id: "player",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                component: "iframe",
                                src: handleTrailerURL(videoId),
                                allowFullScreen: true,
                                allowtransparency: "true",
                                allow: "autoplay",
                                ref: ref38
                            })
                        })
                    })
                }),
                (movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref5 = movieBannerProps.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.film) === null || ref6 === void 0 ? void 0 : ref6.shareLink) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                    "aria-label": "share",
                    sx: (_obj = {
                        width: "40px",
                        height: "40px",
                        background: "rgba(255, 255, 255, 0.5)",
                        borderRadius: "12px",
                        ml: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(51),
                        position: "absolute",
                        top: "16px",
                        right: "16px",
                        display: "none"
                    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("laptop"), {
                        display: "flex"
                    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, "animation", playState ? "translateInfo 1500ms ".concat(theme.transitions.easing.easeInOut, " both ") : ""), _obj),
                    onClick: function() {
                        var ref, ref1;
                        navigator.clipboard.writeText(movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref = movieBannerProps.data) === null || ref === void 0 ? void 0 : (ref1 = ref.film) === null || ref1 === void 0 ? void 0 : ref1.shareLink);
                        setSnack({
                            isOpen: true,
                            message: "movie_details.copied_link_successfully",
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                component: "img",
                                src: copiedIcon
                            }),
                            type: "success"
                        });
                        closeCurrentDialog();
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_image_box_future__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        img: shareWhiteIcon,
                        title: intl.formatMessage({
                            id: "alt.share_icon"
                        }),
                        objectFit: "contain",
                        sx: {
                            width: "24px",
                            height: "24px"
                        }
                    })
                }),
                !((ref8 = (ref7 = ref38.current) === null || ref7 === void 0 ? void 0 : ref7.plyr) === null || ref8 === void 0 ? void 0 : ref8.playing) && videoId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                    "aria-label": "play",
                    sx: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                        width: "58px",
                        height: "58px",
                        background: "rgba(255, 255, 255, 0.5)",
                        borderRadius: "100%",
                        ml: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(51),
                        position: "absolute",
                        top: "calc(50% - 29px)",
                        right: "calc(50% - 29px)",
                        display: "none",
                        zIndex: 100
                    }, theme.breakpoints.down("laptop"), {
                        display: "flex"
                    }),
                    onClick: checkPlaying2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_PlayArrow__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                        sx: {
                            width: "29px",
                            height: "29px",
                            color: theme.palette.common.white
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    component: "div",
                    sx: (_obj1 = {
                        color: theme.palette.common.white,
                        pt: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(1),
                        alignItems: "flex-start",
                        flexDirection: "column",
                        height: "100%",
                        justifyContent: "center",
                        position: "relative",
                        display: "flex",
                        maxWidth: {
                            tablet: "42%",
                            mobile: "100%"
                        }
                    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj1, theme.breakpoints.down("laptop"), {
                        justifyContent: "flex-end"
                    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj1, "transform", "translateX(0%)"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj1, "animation", playState ? "translateLeft 2000ms ".concat(theme.transitions.easing.easeInOut, " both ") : ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj1, "@keyframes translateLeft", {
                        "0%": {
                            display: "block",
                            opacity: 1,
                            transform: "translateX(0%)"
                        },
                        "100%": {
                            opacity: 0,
                            transform: "translateX(-100%)",
                            display: "none"
                        }
                    }), _obj1),
                    children: [
                        (movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref9 = movieBannerProps.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.film) === null || ref10 === void 0 ? void 0 : ref10.bookmark) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            component: "span",
                            sx: {
                                height: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(44),
                                p: 1,
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: " 0px 20px 20px 0px",
                                fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(16),
                                mt: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(239),
                                display: "inlineFlex",
                                color: movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref11 = movieBannerProps.data) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.film) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.bookmark) === null || ref13 === void 0 ? void 0 : ref13.fontColor,
                                backgroundColor: movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref14 = movieBannerProps.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.film) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.bookmark) === null || ref16 === void 0 ? void 0 : ref16.backgroundColor
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_bookmark_name__WEBPACK_IMPORTED_MODULE_3__/* .BookmarkName */ .T, {
                                name: movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref17 = movieBannerProps.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.film) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.bookmark) === null || ref19 === void 0 ? void 0 : ref19.name
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            component: "div",
                            sx: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                                ml: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(68),
                                mt: (movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref20 = movieBannerProps.data) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.film) === null || ref21 === void 0 ? void 0 : ref21.bookmark) ? "121px" : 0,
                                display: "initial"
                            }, theme.breakpoints.down("laptop"), {
                                mt: "48px",
                                mb: "12px",
                                ml: "20px"
                            }),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    component: "div",
                                    sx: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                            component: "h1",
                                            sx: {
                                                fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(30),
                                                fontWeight: "700",
                                                display: "-webkit-box",
                                                overflow: "hidden",
                                                WebkitLineClamp: "2",
                                                WebkitBoxOrient: "vertical"
                                            },
                                            children: movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref22 = movieBannerProps.data) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.film) === null || ref23 === void 0 ? void 0 : ref23.title
                                        }),
                                        (movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref24 = movieBannerProps.data) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.film) === null || ref25 === void 0 ? void 0 : ref25.shareLink) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                            "aria-label": "share",
                                            sx: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                                                width: "68px",
                                                height: "68px",
                                                background: "rgba(255, 255, 255, 0.5)",
                                                borderRadius: "12px",
                                                ml: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(51)
                                            }, theme.breakpoints.down("laptop"), {
                                                display: "none"
                                            }),
                                            onClick: function() {
                                                var ref, ref1;
                                                navigator.clipboard.writeText(movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref = movieBannerProps.data) === null || ref === void 0 ? void 0 : (ref1 = ref.film) === null || ref1 === void 0 ? void 0 : ref1.shareLink);
                                                setSnack({
                                                    isOpen: true,
                                                    message: "movie_details.copied_link_successfully",
                                                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                        component: "img",
                                                        src: copiedIcon
                                                    }),
                                                    type: "success"
                                                });
                                                closeCurrentDialog();
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_image_box_future__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                img: shareWhiteIcon,
                                                title: intl.formatMessage({
                                                    id: "alt.share_icon"
                                                }),
                                                objectFit: "contain",
                                                sx: {
                                                    width: "24px",
                                                    height: "24px"
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    component: "div",
                                    sx: {
                                        display: "flex",
                                        mt: {
                                            laptop: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(11),
                                            tablet: "20px"
                                        },
                                        alignItems: "center"
                                    },
                                    children: [
                                        formattedDuration && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                            "aria-label": "time",
                                            sx: {},
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_image_box_future__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                img: timeIcon,
                                                title: intl.formatMessage({
                                                    id: "alt.time_icon"
                                                }),
                                                objectFit: "contain",
                                                sx: {
                                                    width: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(28),
                                                    height: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(28)
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                            component: "p",
                                            sx: {
                                                fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(24)
                                            },
                                            children: durationWithRateWithRtl
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                    component: "span",
                                    sx: {
                                        fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(30),
                                        mt: {
                                            laptop: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(11),
                                            tablet: "4px"
                                        }
                                    },
                                    children: movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref26 = movieBannerProps.data) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.film) === null || ref27 === void 0 ? void 0 : ref27.genres.slice(0, 2).map(function(genre, index) {
                                        return "".concat(genre.name, " ").concat(index !== 1 ? " . " : "");
                                    })
                                })
                            ]
                        })
                    ]
                }),
                (movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref28 = movieBannerProps.data) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.film) === null || ref29 === void 0 ? void 0 : ref29.image) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_image_box_future__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    img: movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref30 = movieBannerProps.data) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.film) === null || ref31 === void 0 ? void 0 : ref31.image,
                    title: (movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref32 = movieBannerProps.data) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.film) === null || ref33 === void 0 ? void 0 : ref33.imageAlt) || (movieBannerProps === null || movieBannerProps === void 0 ? void 0 : (ref34 = movieBannerProps.data) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.film) === null || ref35 === void 0 ? void 0 : ref35.title),
                    layout: "intrinsic",
                    objectFit: "cover",
                    width: "1600px",
                    height: "2400px",
                    sx: (_obj2 = {
                        width: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(570),
                        borderRadius: "20px",
                        overflow: "hidden",
                        marginRight: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(65),
                        position: "relative"
                    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj2, theme.breakpoints.down("laptop"), {
                        display: "none"
                    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj2, "transform", "translateX(0%)"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj2, "animation", playState ? "translateRight 2000ms ".concat(theme.transitions.easing.easeInOut, " both ") : ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj2, "@keyframes translateRight", {
                        "0%": {
                            display: "flex",
                            opacity: 1,
                            transform: "translateX(0%)"
                        },
                        "100%": {
                            opacity: 0,
                            transform: "translateX(+100%)",
                            display: "none !important"
                        }
                    }), _obj2)
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MovieBanner);


/***/ }),

/***/ 48185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ BookmarkName; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./src/constants/movie-types-enum.ts
var movie_types_enum = __webpack_require__(15432);
;// CONCATENATED MODULE: ./src/logic/helpers/clip-text.ts
var clipText = function(text, maxLength) {
    if (text.length > maxLength) {
        return text.slice(0, maxLength) + "...";
    } else {
        return text;
    }
};

;// CONCATENATED MODULE: ./src/components/shared/bookmark-name.tsx




var BookmarkName = function(param) {
    var name = param.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        title: name,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "span",
            children: clipText(name, movie_types_enum/* BOOKMARK_NAME_MAX_LENGTH */.B)
        })
    });
};


/***/ })

}]);